(function () {
  'use strict';

  var EVENT_NAME = 'ae_awards:call_clicked';
  var GOOGLE_ANALYTICS_SEND_TO = 'G-5FLQ9MQFS3';
  var GOOGLE_WEBSITE_CALLS_SEND_TO = 'AW-18168074921/htClCMmusNscEKmlm9dD';
  var GOOGLE_PHONE_NUMBER = '(407) 450-0763';
  var FIRST_TOUCH_KEY = 'ae:first-touch:v1';

  function safeValue(value) {
    return String(value || '').trim().toLowerCase().slice(0, 80);
  }

  function classifySource(params, referrer) {
    var utmSource = safeValue(params.get('utm_source'));
    var hostname = '';

    if (params.has('gclid') || utmSource === 'google') return 'google';
    if (
      params.has('fbclid') ||
      utmSource === 'facebook' ||
      utmSource === 'fb' ||
      utmSource === 'meta' ||
      utmSource === 'instagram'
    ) {
      return 'facebook';
    }

    if (utmSource) return utmSource;
    if (!referrer) return 'direct';

    try {
      hostname = new URL(referrer).hostname.replace(/^www\./, '').toLowerCase();
    } catch (error) {
      return 'referral';
    }

    if (hostname.indexOf('google.') === 0 || hostname === 'google.com') return 'google';
    if (
      hostname === 'facebook.com' ||
      hostname.slice(-13) === '.facebook.com' ||
      hostname === 'instagram.com' ||
      hostname.slice(-14) === '.instagram.com'
    ) {
      return 'facebook';
    }
    return 'referral';
  }

  function currentTouch() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      params = { get: function () { return ''; }, has: function () { return false; } };
    }

    return {
      traffic_source: classifySource(params, document.referrer),
      landing_path: window.location.pathname
    };
  }

  function firstTouch() {
    var touch;
    try {
      touch = JSON.parse(window.sessionStorage.getItem(FIRST_TOUCH_KEY) || 'null');
    } catch (error) {
      touch = null;
    }

    if (touch && touch.traffic_source && touch.landing_path) return touch;
    touch = currentTouch();

    try {
      window.sessionStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(touch));
    } catch (error) {}
    return touch;
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'aec-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function themeValue(key) {
    if (!window.Shopify || !window.Shopify.theme) return '';
    return String(window.Shopify.theme[key] || '');
  }

  function isLiveTheme() {
    return themeValue('role').toLowerCase() === 'main';
  }

  function googleTag() {
    window.dataLayer = window.dataLayer || [];
    return typeof window.gtag === 'function'
      ? window.gtag
      : function () { window.dataLayer.push(arguments); };
  }

  function callLocation(link) {
    if (link.dataset && link.dataset.aeCallLocation) return link.dataset.aeCallLocation;
    if (link.closest('.ae-masthead')) return 'masthead';
    if (link.closest('.ae-quote-form__confirmation')) return 'quote_confirmation';
    if (link.closest('.ae-event-lander__assistance')) return 'event_assistance';
    if (link.closest('.ae-contact-page')) return 'contact_page';
    if (link.closest('.ae-pricing')) return 'pricing_page';
    if (link.closest('.ae-mod-hero')) return 'hero';
    return 'other';
  }

  function publishShopifyEvent(data) {
    if (
      !window.Shopify ||
      !window.Shopify.analytics ||
      typeof window.Shopify.analytics.publish !== 'function'
    ) {
      return;
    }

    try {
      var result = window.Shopify.analytics.publish(EVENT_NAME, data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (error) {}
  }

  function configureGoogleWebsiteCalls() {
    if (!isLiveTheme()) return;

    try {
      googleTag()('config', GOOGLE_WEBSITE_CALLS_SEND_TO, {
        phone_conversion_number: GOOGLE_PHONE_NUMBER
      });
    } catch (error) {}
  }

  function publishGoogleClickTracking(data) {
    if (!isLiveTheme()) return;

    try {
      googleTag()('event', 'phone_contact_clicked', {
        send_to: GOOGLE_ANALYTICS_SEND_TO,
        event_id: data.event_id,
        link_location: data.link_location,
        traffic_source: data.traffic_source
      });
    } catch (error) {}
  }

  function onCallClick(event) {
    var link = event.target && event.target.closest
      ? event.target.closest('a[href^="tel:"]')
      : null;
    var touch;
    var id;
    var data;

    if (!link) return;
    touch = firstTouch();
    id = eventId();
    data = {
      event_id: id,
      destination: link.getAttribute('href').replace(/^tel:/i, ''),
      link_location: callLocation(link),
      page_path: window.location.pathname,
      landing_path: touch.landing_path,
      traffic_source: touch.traffic_source,
      theme_id: themeValue('id'),
      theme_role: themeValue('role')
    };

    publishShopifyEvent(data);
    publishGoogleClickTracking(data);
  }

  firstTouch();
  configureGoogleWebsiteCalls();
  document.addEventListener('click', onCallClick, true);
})();
